export default __webpack_public_path__ + "static/media/profile.c69f02d0.jpeg";